@if(isTabActive && !isViewMode) {
<div class="d-lg-flex flex-row justify-content-end soap-header gap-3 mb-1 w-100 speech-container" #speechHost>
  @if(selectedSpeechProvider === 'azure'){
  <lib-speech-to-text [dateFormat]="''" [startRecordingLabel]="''" [stopRecordingLabel]="''" [showDate]="false"
    [recordingTimeLabel]="''" (startAndStop)="checkStartAndStop($event)" (sendRecordedText)="recordedText($event)"
    (recognizing)="recognizingText($event)"></lib-speech-to-text>
  }@else if(selectedSpeechProvider === 'audio-chunks'){
  <cva-speech-to-text-chunked [dateFormat]="'d MMM, y'" [startRecordingLabel]="startDictationLabel"
    [stopRecordingLabel]="stopDictationLabel" (startAndStop)="checkStartAndStop($event)"
    (sendRecordedText)="recordedText($event)" (recognizing)="recognizingText($event)" [isDectation]=true
    [showLabel]="false" (speechStatus)="onSpeechStatus($event)"></cva-speech-to-text-chunked>
  }
</div>
}

<div class="outer-border soap-content mx-2">
  @if(false){
  <div *ngIf="!hideLeftSection && !isMobileView()" class="d-flex flex-column"
    [ngClass]="{ 'left-section' : !toggleState, 'toggle-on-left' : toggleState }">
    <mat-card appearance="outlined" class="mat-card-custom h-100 flex-fill">
      <mat-card-header>
        <mat-card-title>Symptoms Identified</mat-card-title>
      </mat-card-header>
      <mat-card-content class="symptoms-card-content card-content">Coming soon...</mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="mat-card-custom mt-2 h-100 flex-fill">
      <mat-card-header>
        <mat-card-title>Suggested Medications</mat-card-title>
      </mat-card-header>
      <mat-card-content class="medications-card-content card-content">Coming soon...</mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="mat-card-custom mt-2 h-100 flex-fill"
      [ngStyle]="{'display': toggleState ? 'none' : 'block'}">
      <mat-card-header class="d-flex justify-content-between align-items-center">
        <mat-card-title>Suggested Questions</mat-card-title>

        <mat-slide-toggle [(ngModel)]="toggleState" class="toggle-button" color="primary" hideIcon="true">
        </mat-slide-toggle>
      </mat-card-header>

      <mat-card-content class="questions-card-content card-content">Coming soon...</mat-card-content>
    </mat-card>
  </div>
  }
  <div *ngIf="!hideLeftSection && !isMobileView()" class="mid-section"
    [ngStyle]="{'display': toggleState ? 'block' : 'none'}">
    <mat-card appearance="outlined" class="mat-card-custom h-100 flex-fill">
      <mat-card-header class="d-flex justify-content-between align-items-center">
        <mat-card-title>Suggested Questions</mat-card-title>

        <mat-slide-toggle [(ngModel)]="toggleState" class="toggle-button" color="primary" hideIcon="true">
        </mat-slide-toggle>
      </mat-card-header>

      <mat-card-content class="mid-questions-card-content card-content">Coming soon...</mat-card-content>
    </mat-card>
  </div>

  <div [ngClass]="{ 'right-section' : !toggleState, 'toggle-on-right' : toggleState }">
    <mat-card class="card">

      <mat-card class="card-header">

        <button type="button" mat-mini-fab class="pencil-button record-ico pointer" alt="Edit" *ngIf="isViewMode"
          title="Go back to record transcription" (click)="goToEditMode()">
          <mat-icon>edit</mat-icon>
        </button>

      </mat-card>

      <mat-card-content [ngClass]="[isLIC ? 'transcriptionLIC' : 'transcription']">
        @if (isViewMode || !editableTranscript) {
        <div class="main-body view-transcription">{{ transcription }}</div>
        } @else {
        <div class="textarea-wrapper">
          <div class="textarea-placeholder"
            *ngIf="!transcription && !(recordingStarted) && liveTranscriptionEnabled !== null">{{
            textAreaPlaceHolder }}</div>
          <textarea placeholder="" name="transcription" [(ngModel)]="transcription"
            class="p-2 textarea-font transcript-textarea" #textareaRef
            [class.pref-pending]="liveTranscriptionEnabled === null"
            [class.has-live-overlay]="liveTranscriptionEnabled && !!sttUIStatus"
            (ngModelChange)="onTextChange($event)"></textarea>

          <cva-transcript-overlay [liveText]="liveTranscriptionEnabled" [provider]="selectedSpeechProvider"
            [recording]="recordingStarted" [status]="sttUIStatus" [hasTranscript]="!!transcription"
            (micClick)="startFromOverlay()"></cva-transcript-overlay>

        </div>
        }
      </mat-card-content>

      <div class="footer" *ngIf="!isViewMode">
        <button type="button" class="btn btn-dark btn-sm second-element" mdbRipple (click)="save()" cvaAuthPermCheck
          [moduleName]="CVA_AUTH_MODULES.CVA_SOAP_NOTES" [permissionType]="CVA_CONSTANTS.PERMISSION.WRITE"
          [actionType]="'disable'" [disabled]="!hasText || actionsDisabled">
          Save
        </button>

        <div class="action-btn-group">
          <cva-generate-button #generateMoreBtn [name]="'Generate More'" (actionClick)="generateMore($event)"
            [noteTemplateListing]="noteTemplateListing" [hasDefaultTemplate]="true"
            [DEFAULT_PREFERRED_TEMPLATE]="DEFAULT_PREFERRED_TEMPLATE" [transcription]="transcription"
            [appointmentRefId]="appointmentRefId" [vitals]="vitals" [patientHistory]="patientHistory"
            [disabled]="actionsDisabled"></cva-generate-button>

          <cva-generate-button [name]="'Generate'" (actionClick)="generate($event)"
            [noteTemplateListing]="noteTemplateListing" [hasDefaultTemplate]="hasDefaultTemplate"
            [DEFAULT_PREFERRED_TEMPLATE]="DEFAULT_PREFERRED_TEMPLATE" [transcription]="transcription"
            [appointmentRefId]="appointmentRefId" [vitals]="vitals" [patientHistory]="patientHistory"
            [disabled]="actionsDisabled"></cva-generate-button>

          <button type="button" class="btn btn-outline-primary btn-sm cdm-btn" (click)="openCdmModal(cdmDialogTemplate)"
            [disabled]="isCdmPlanLoading || isCdmSourceLoading || !hasText || actionsDisabled">
            CDM
          </button>
        </div>
      </div>
    </mat-card>
  </div>
</div>

<ng-template #cdmDialogTemplate>
  <cva-cdm-plan-modal [title]="'Chronic Condition Management'" [showTitleIcon]="false" [showEligibilityLabel]="true"
    [patientName]="cdmPatientName" [patientDob]="cdmPatientDob" [patientMrn]="cdmPatientMrn"
    [patientGender]="cdmPatientGender" [patientId]="cdmPatientId" [isLoading]="isCdmPlanLoading"
    [errorMessage]="cdmPlanError" [rawResponse]="cdmPlanResponse" [eligibility]="cdmEligibility"
    [eligibilityReason]="cdmEligibilityReason" [annualSmartGoal]="cdmAnnualSmartGoal" [planRows]="cdmPlanRows"
    [screeningRows]="cdmHealthScreeningRows">
  </cva-cdm-plan-modal>
</ng-template>